'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = typeof window === 'undefined' ? global : window;


//////////////////
// WEBPACK FOOTER
// ./~/jss/lib/utils/global.js
// module id = 172
// module chunks = 0